import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseHttpService<T> {
  protected endpoint: string = '';
  protected readonly client: HttpClient;

  constructor(client: HttpClient) {
    this.client = client;
    this.init();
  }

  protected init() { }

  get url(): string {
    return `${environment.apiUrl}${this.endpoint}`;
  }

  fetchAll(url?: string): Observable<T> {
    return this.client.get<T>(url ? url : this.url);
  }

  get(id: string | number, url?: string): Observable<T> {
    return this.client.get<T>(`${url ? url : this.url}/${id}`);
  }

  list(params: any, url?: string): Observable<T[]> {
    return this.client.get<T[]>(url ? url : this.url, { params });
  }

  create(data: any, url?: string): Observable<T> {
    return this.client.post<T>(url ? url : this.url, data);
  }

  update(id: number | string, data: any, url?: string): Observable<T> {
    return this.client.put<T>(`${url ? url : this.url}/${id}`, data);
  }

  delete(id: number | string, url?: string) {
    return this.client.delete(`${url ? url : this.url}`);
  }
}